import { render, staticRenderFns } from "./InventoyPiecesProcessedL2PChart.vue?vue&type=template&id=4a679c7e&scoped=true&"
import script from "./InventoyPiecesProcessedL2PChart.vue?vue&type=script&lang=js&"
export * from "./InventoyPiecesProcessedL2PChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a679c7e",
  null
  
)

export default component.exports